import React, { useContext, useState, useEffect, useRef, Fragment } from 'react'
import moment from 'moment'
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
  EyeOutlined,
} from '@ant-design/icons'
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  message,
  Spin,
  Space,
} from 'antd'
import { Link } from 'react-router-dom'
import Highlighter from 'react-highlight-words'
import './SimpleTable.scss'
import { HTTPService } from '../../otherServices/apiService'
import {
  DATE_FORMAT,
  ORDER_SORTING,
  PERMISSIONS_BY_NAME,
} from '../../otherServices/constant'
import SimpleTableForm from './SimpleTableForm'
import CustomerAuditLog from './CustomerAuditLog'
import {
  downloadExcel,
  isPermission,
} from '../../otherServices/commonFunction'
import { ExportToCsv } from 'export-to-csv'


let { Search } = Input
let selectedReports = []

const EditableContext = React.createContext()
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm()
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  )
}

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false)
  const inputRef = useRef()
  const form = useContext(EditableContext)
  useEffect(() => {
    if (editing) {
      inputRef.current.focus()
    }
  }, [editing])

  const toggleEdit = () => {
    setEditing(!editing)
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    })
  }

  const save = async (e) => {
    try {
      const values = await form.validateFields()
      toggleEdit()
      handleSave({ ...record, ...values })
    } catch (errInfo) {
      
    }
  }

  let childNode = children

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 20,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    )
  }

  return <td {...restProps}>{childNode}</td>
}

class SimpleTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
  }

   //search function for table columns
   getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, clearFilters }) => (
      <div className="search_filterDropdown">
        <Input
          className="search_input"
          ref={(node) => {
            this.searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            clearFilters()
            this.onSearch(`${dataIndex}=${selectedKeys[0].trim()}`)
          }}
        />
        <Space className="btns">
          <Button
            type="primary"
            onClick={() => {
              clearFilters()
              this.onSearch(`${dataIndex}=${selectedKeys[0].trim()}`)
            }}
            icon={<SearchOutlined />}
            size="medium"
          >
            Search
          </Button>
          <Button
            onClick={() => {
              this.onFilterResetReport(`${dataIndex}`)
            }}
            size="medium"
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#3653AA' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select())
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#fafafa', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  })
 //search function
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    })
  }
 //function to reset filter
  handleReset = (clearFilters) => {
    clearFilters()
    this.setState({ searchText: '', filterValueArray: [] })
  }

  //table column properties
  constructor(props) {
    super(props)

    this.state = {
      count: 2,
      dataSource: [],
      count: 0,
      currentPage: 1,
      isFormOpen: false,
      isAuditFormOpen: false,
      currentRecord: null,
      loader: false,
      searchText: '',
      filterApplied: null,
      isAddPart: false,
      isAuditPart: false,
      filterValueArray: [],
      selectedReportIds: [],
      isFilter: false,
      pageLimit: 20,
      filterString: '',
      selectedReport: [],
      isFilterText: false,
      selectAllExportData: [],
      selectedallReport: [],
      highlightFilterArray: [],
      exportAllData: [],
      loadingExportData: false,
    }
    this.getFormData = this.getFormData.bind(this)
  }

  componentDidMount() {
    
    if (this.state.isFilter) {
      this.getFilteredReport(this.state.filterString)
    } else {
      this.getFormData('')
    }
  }

  //function to fetch table data
  async getFormData(searchValue = '', currentPage = 1) {
    let offset = (currentPage - 1) * this.state.pageLimit
    let urlLink = `customer-channel/?${ORDER_SORTING}&limit=${
      this.state.pageLimit
    }&offset=${offset}${searchValue && { searchValue }}`
    this.setState({ loader: true, highlightFilterArray: [] })
    try {
      let res = await HTTPService({
        method: 'GET',
        url: urlLink,
      })
      if (res.success) {
        let reports = []
        for (let report of res.data.results) {
          reports.push({ ...report, key: report.id })
        }
        this.setState({
          dataSource: reports,
          count: res.data.count,
          loader: false,
          searchText: searchValue || null,
          currentPage,
          isFilter: false,
          filterApplied: searchValue,
          filterValueArray: [],
          selectedReport: [],
        })
        message.success('Fetched Successfully')
      } else {
        message.error(res.message)
        this.setState({
          dataSource: [],
          count: 0,
          loader: false,
          searchText: searchValue || null,
          currentPage,
         
        })
        message.error(res.message)
      }
    } catch (error) {
      message.error('Failed to Fetch')
      this.setState({
        dataSource: [],
        count: 0,
        loader: false,
        searchText: searchValue || null,
        currentPage,
      })
      
    }
  }
  
   //function to fetch filtered table data
  async getFilteredReport(searchValue = '', currentPage = 1) {
    let urlLink = `customer-channel/?${ORDER_SORTING}&${searchValue}`
    this.setState({ loader: true })
    try {
      let userRes = await HTTPService({
        method: 'GET',
        url: urlLink,
      })
      if (userRes.success) {
        let reports = []
        for (let o of userRes.data.results) {
          reports.push({ ...o, key: o.id })
        }
        this.setState({
          dataSource: reports,
          count: userRes.data.count,
          loader: false,
          searchText: searchValue || null,
          currentPage,
          filterApplied: searchValue,
        })
        message.success('Filter Applied')
      } else {
        this.setState({ loader: false })
        message.error(userRes.message)
      }
    } catch (error) {
      this.setState({ loader: false })
      message.error('Filter Not Applied')
    }
  }

  //search function
  onSearch = (value = '') => {
    let arrayOfFilter = this.state.filterValueArray
    arrayOfFilter.filter((i, index) => {
      let stringSplit = value.split('=')
      if (i.includes(stringSplit[0])) {
        arrayOfFilter.splice(index, 1)
        return i
      }
    })
    arrayOfFilter.push(value)
    let highlightArray = []
    let isFilterColor = arrayOfFilter.map((i) => {
      highlightArray.push(i.split('=')[0])
    })
    this.setState({
      filterValueArray: arrayOfFilter,
      isFilter: true,
      filterString: `${arrayOfFilter.join('&&')}`,
      highlightFilterArray: highlightArray,
    })
    this.getFilteredReport(`${arrayOfFilter.join('&&')}`)
  }

  //function to reset the applied filter
  onFilterResetReport = (value = '') => {
    let arrayOfFilter = this.state.filterValueArray
    arrayOfFilter.filter((i, index) => {
      if (i.includes(value)) {
        arrayOfFilter.splice(index, 1)
        return i
      }
    })
    let highlightArray = []
    let isFilterColor = arrayOfFilter.map((i) => {
      highlightArray.push(i.split('=')[0])
    })
    this.setState({
      filterValueArray: arrayOfFilter,
      isFilter: true,
      highlightFilterArray: highlightArray,
    })
    if (arrayOfFilter.length == 0) {
      this.getFormData('')
    } else {
      this.setState({ filterString: `${arrayOfFilter.join('&&')}` })
      this.getFilteredReport(`${arrayOfFilter.join('&&')}`)
    }
  }

  //function to delete table record
  handleDelete = async (key) => {
    try {
      await HTTPService({
        url: `customer-channel/${key}/`,
        method: 'DELETE',
      })
      message.success('Record Deleted')
      this.getFormData('', this.state.currentPage)
    } catch (ex) {
      if (ex.response.status === 500) message.error('Internal Server Error')
    }
  }

  handleSave = (row) => {
    const newData = [...this.state.dataSource]
    const index = newData.findIndex((item) => row.key === item.key)
    const item = newData[index]
    newData.splice(index, 1, { ...item, ...row })
    this.setState({
      dataSource: newData,
    })
  }

  
  //function to toggle flag to open Add/Edit form
  setReportStatus = (report, mode) => {
    if (mode == 'edit') {
      this.setState({ isAddPart: false })
    } else {
      this.setState({ isAddPart: true })
    }
    this.setState({
      isFormOpen: !this.state.isFormOpen,
      currentRecord: report ? report : null,
    })
    }

//add Audit Log
setAuditLog = (report, mode) => {
  if (mode == 'edit') {
    this.setState({ isAuditPart: false })
  } else {
    this.setState({ isAuditPart: true })
  }
  this.setState({
    isAuditFormOpen: !this.state.isAuditFormOpen,
    currentRecord: report ? report : null,
  })
  }

  handleSave = (row) => {
    const newData = [...this.state.dataSource]
    const index = newData.findIndex((item) => row.id === item.id)
    const item = newData[index]
    newData.splice(index, 1, { ...item, ...row })
    this.setState({
      dataSource: newData,
    })
  }

  //function to fetch data fot table on page change
  onChangePageNumber = async (pageNumber, PAGE_LIMIT) => {
    this.setState({ 
      loader: true, 
      pageLimit: PAGE_LIMIT, 
      selectedReport: [], 
    })
    let offset = (pageNumber - 1) * PAGE_LIMIT
    try {
      let reportRes
      if (this.state.isFilter) {
        
        reportRes = await HTTPService({
          method: 'GET',
          url: `customer-channel/?${this.state.searchText}&${ORDER_SORTING}&limit=${PAGE_LIMIT}&offset=${offset}`,
        })
      } else {
        reportRes = await HTTPService({
          method: 'GET',
          url: `customer-channel/?${ORDER_SORTING}&limit=${PAGE_LIMIT}&offset=${offset}`,
        })
      }
      if (reportRes.success) {
        let reports = [],
          count = 0
        for (let report of reportRes.data.results) {
          reports.push({ ...report, key: report.id })
        }

        count = reportRes.data.count
        this.setState({
          dataSource: reports,
          count,
          currentPage: pageNumber,
          currentRecord: null,
          isFormOpen: false,
          loader: false,
        })
      } else {
        message.error(reportRes.message)
        this.setState({
          isFormOpen: false,
          loader: false,
        })
      }
    } catch {
      message.error('Failed to Fetch')
      this.setState({
        isFormOpen: false,
        loader: false,
      })
    }
  }

  //function to display total item
  showTotal = () => {
    return `Total ${this.state.count}`
  }

  exportData = () => {
    if (this.state.isFilter) {
      this.getExportDataFiltered()
    } else {
      this.getExportData()
    }
  }
 
  async getExportDataFiltered() {
    let urlLink = `export/cust-channel-csv/?${this.state.searchText}`
    let responseURL
    try {
      let userRes = await HTTPService({
        method: 'GET',
        url: urlLink,
      })
      if (userRes.success) {
        responseURL = userRes.data.url
        this.setState({ exportURL: responseURL })
        window.location.href = responseURL
      } else {
        this.setState({ loader: false })
        message.error(userRes.message)
      }
    } catch (error) {
      this.setState({ loader: false })
      
    }
  }
  async getExportData() {
    let urlLink = `export/cust-channel-csv/`
    let responseURL
    try {
      let userRes = await HTTPService({
        method: 'GET',
        url: urlLink,
      })
      if (userRes.success) {
        responseURL = userRes.data.url
        this.setState({ exportURL: responseURL })
        window.location.href = responseURL
      } else {
        this.setState({ loader: false })
        message.error(userRes.message)
      }
    } catch (error) {
      this.setState({ loader: false })
      
    }
  }

  render() {
    this.columns = [
      
       
      {
        title: 'Customer Name',
        dataIndex: 'disti_name',
        ...this.getColumnSearchProps('disti_name'),
        width: '20%',
        className: (this.state.highlightFilterArray.includes('disti_name') ? 'filtered_text' : '')
      },
      {
        title: 'Is stocking rep',
        dataIndex: 'is_stocking_rep',
        ...this.getColumnSearchProps('is_stocking_rep'),
        width: '20%',
        className: (this.state.highlightFilterArray.includes('is_stocking_rep') ? 'filtered_text' : ''),

       },
      {
        title: 'TYT Distributor',
        dataIndex: 'tyt_distributors',
        ...this.getColumnSearchProps('tyt_distributors'),
        width: '20%',
        className: (this.state.highlightFilterArray.includes('tyt_distributors') ? 'filtered_text' : ''),
        
      }
    ]

    //Action button columns
    if (isPermission(PERMISSIONS_BY_NAME['Manage Customer channel'])) {
      this.columns.push({
        title: 'Action',
        dataIndex: 'action',
        fixed: 'right',
        width: 80,
        align: 'center',
        render: (text, record) =>
          this.state.dataSource.length >= 1 ? (
            <Fragment>
              <Link className="ico_edit">
                <EditOutlined
                  onClick={() => this.setReportStatus(record, 'edit')}
                />
              </Link>
              
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={() => this.handleDelete(record.id)}
                >
                  <Link className="ico_delete">
                    <DeleteOutlined />
                  </Link>
                </Popconfirm>
            </Fragment>
          ) : null,
      })
    } else if (isPermission(PERMISSIONS_BY_NAME['View Customer channel'])) {
      this.columns.push({
        title: 'Action',
        dataIndex: 'action',
        fixed: 'right',
        width: 80,
        align: 'center',
        render: (text, record) =>
          this.state.dataSource.length >= 1 ? (
            <Fragment>
              <span className="ico_edit">
                <EyeOutlined
                  onClick={() => this.setReportStatus(record)}
                />
              </span>
            </Fragment>
          ) : null,
      })
    }else if (isPermission(PERMISSIONS_BY_NAME['Manage Customer channel'])) {
      this.columns.push({
        title: 'Action',
        dataIndex: 'action',
        width: '10%',
        render: (text, record) =>
          this.state.dataSource.length >= 1 ? (
            <Fragment>
              <span className="ico_edit">
                <EditOutlined onClick={() => this.setReportStatus(record)} />
              </span>
            </Fragment>
          ) : null,
      })
    }
    //function to select records/rows of table
    const rowSelection = {
      selectedRowKeys: this.state.selectedReport,
      onChange: (selectedReports, selectedRows) => {
        this.setState({ selectedReport: selectedReports })
        
      },
    }
    const { dataSource, currentPage, count } = this.state
    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    }
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col

      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      }
    })

   

    const renderTable = () => {
      return (
        <div className="SimpleTableStyles">
          <div className="SimpleTable_container">
            <div className="Table_top_row">
              <div className="Table_heading">Customer Channel </div>
              <div className="Table_action_btns">
                <Button
                  onClick={() => this.setAuditLog('', 'edit')}
                  type="primary"
                  className="login-form-button"
                  size="large"
                >
                  Audit Log
                </Button>
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => this.getFormData('')}
                  >
                    Reset
                  </Button>
                <Button
                  type="default"
                  size="large"
                  onClick={() => {
                    let selectedReportData = this.state.selectedReport
                    let data = []
                    this.state.dataSource.filter((i,key) => {
                      let mpnData = i.id
                      let index = selectedReportData.indexOf(mpnData)
                      if (index != -1) {
                        data.push(this.state.dataSource[key])
                      }
                    })

                    if (this.state.selectedReport.length > 0) {
                      let fileContent = []
                      for (let report of data) {
                        let csvObj = {}
                        for (let column of this.columns) {
                          if (column.dataIndex !== 'action') {
                            csvObj[column.dataIndex] = report[column.dataIndex]
                          }
                        }
                        fileContent.push(csvObj)
                      }
                      let headersToShow = this.columns
                        .map(
                          (column) =>
                            column.dataIndex !== 'action' && column.title
                        )
                        .filter((value) => value && value)
                      downloadExcel(
                        'RoreOrder_import',
                        fileContent,
                        headersToShow
                      )
                    } else message.info('Select order to export')
                  }}
                >
                  Export
                </Button>
                
                <a
                  onClick={() => this.exportData(columns)}
                  className="export_link"
                  download
                >
                  Export All
                </a>
                
                {isPermission(PERMISSIONS_BY_NAME['Manage Customer channel']) && (
                  <Button
                    onClick={() => this.setReportStatus('', 'add')}
                    size="large"
                    type="primary"
                  >
                    Add Customer
                  </Button>
                )}
              </div>
            </div>
            <div className="layout_content_box CatalogTableEdit_whitebox">
              <Table //render report table
                className="Table_block_main"
                components={components}
                scroll={{ y: 500 }}
                rowClassName={() => 'editable-row'}
                bordered
                rowSelection={{
                  ...rowSelection,
                }}
                dataSource={dataSource || null}
                columns={columns}
                pagination={{
                  onChange: this.onChangePageNumber,
                  current: currentPage,
                  total: count,
                  defaultPageSize: this.state.pageLimit,
                  showSizeChanger: true,
                  onShowSizeChange: this.onChangePageNumber,
                  showTotal: this.showTotal,
                }}
                loading={this.state.loader}
                rowKey="id"
              />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div>
        {this.state.isFormOpen ? (
          this.state.loader ? (
            <div className="loader">
              <Spin size='large' />{' '}
            </div>
          ) : (
            //Add/Edit Form
            <SimpleTableForm
              record={this.state.currentRecord}
              currentPage={this.state.currentPage}
              onChangePageNumber={this.onChangePageNumber}
              setReportStatus={this.setReportStatus}
              isAddPart={this.state.isAddPart}
              pageLimit={this.state.pageLimit}
            />
          )
        ) : (
          this.state.isAuditFormOpen ? <CustomerAuditLog 
          setAuditLog={this.setAuditLog}/> :
          renderTable()
        )}
      </div>
    )
  }
}

export default SimpleTable
